module.exports = __webpack_public_path__ + "static/img/caiPath.a74e67e3.gif";